import type { LegacyProfile } from '../model/schema';

/**
 * Whether the merchant trades as a legal entity, for the profile card's
 * account-type pill.
 *
 * Read off `legal_form` when the backend sends a known form (`COMPANY` is a
 * legal entity, `INDIVIDUAL` is not); while the form is absent, null or
 * `LEGAL_FORM_UNSPECIFIED`, fall back to the legacy `is_corporate` flag so
 * the pill keeps working during the migration.
 */
export function legacyIsLegalEntity(
  profile: Pick<LegacyProfile, 'legal_form' | 'is_corporate'> | undefined,
): boolean {
  if (!profile) return false;
  switch (profile.legal_form ?? null) {
    case 'LEGAL_FORM_COMPANY':
      return true;
    case 'LEGAL_FORM_INDIVIDUAL':
      return false;
    default:
      return profile.is_corporate;
  }
}
